module.exports = __webpack_public_path__ + "img/rewards-bubble-8.87b11258.svg";